export default __webpack_public_path__ + "static/img/xevant-logo-horizontal.7ad65bceee90579c968c248c8b9a0636.png";